var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardShell',[_c('UnderlinedHeading',{staticClass:"ph3 ph4-ns"},[_vm._v("People were also interested in...")]),_c('ToolList',{attrs:{"tools":_vm.similarListings}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }